import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import * as qs from 'qs';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import WindsorApi from '../../api/WindsorApi';
import LinkRouter from '../../common/LinkRouter';
import LoadingIndicator from '../../common/LoadingIndicator';
import MobxContext from '../../mobx/MobxContext';
import FaroParamSetForm from './FaroParamSetForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    }
  })
);

const windsorApi = new WindsorApi();

function FaroParamSetCreatePage(props: RouteComponentProps<any> & WithSnackbarProps) {
  const { location, history, enqueueSnackbar } = props;
  const { defaultEnvironmentName, defaultRegion, cloneFrom } = qs.parse(location.search, { ignoreQueryPrefix: true });
  const classes = useStyles({});
  const [paramSet, setParamSet] = useState(null);
  const [assumeRoleArn, setAssumeRoleArn] = useState(null);

  const { environmentStore } = useContext(MobxContext);

  useEffect(() => {
    if (cloneFrom) {
      const cloneFromJson = JSON.parse(cloneFrom);
      windsorApi.getFaroParameterSet(cloneFromJson.name, cloneFromJson.version, cloneFromJson.accountId, cloneFromJson.region).then(res => {
        setParamSet({
          name: `${res.Name}-clone`,
          accountId: res.AccountID,
          region: res.Region,
          parameters: res.Parameters
        });
      });
    } else if (environmentStore.environments) {
      setParamSet({
        name: '',
        accountId: defaultEnvironmentName ? environmentStore.getEnvironmentByName(defaultEnvironmentName).AccountID : '',
        region: defaultRegion || '',
        parameters: []
      });
    }
  }, [environmentStore, environmentStore.environments, defaultEnvironmentName, defaultRegion, cloneFrom]);

  const onCancel = () => {
    history.push(`/faro/parameters${defaultEnvironmentName && defaultRegion ? `?environmentName=${defaultEnvironmentName}&region=${defaultRegion}` : ''}`);
  };

  const onSave = () => {
    return windsorApi.createParameterSetVersion({
      Name: paramSet.name,
      Parameters: paramSet.parameters
    }, paramSet.accountId, paramSet.region, assumeRoleArn).then(res => {
      enqueueSnackbar(`Parameter set ${res.Name} created`);
      return res;
    });
  };

  const onSaveComplete = (res) => {
    history.push(`/faro/parameters/${res.AccountID}/${res.Region}/${res.Name}`);
  };

  return paramSet && environmentStore.environments ? (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="textSecondary" to={`/faro/parameters${defaultEnvironmentName && defaultRegion ? `?environmentName=${defaultEnvironmentName}&region=${defaultRegion}` : ''}`}>
          Parameter Sets
        </LinkRouter>
        <Typography color="textPrimary">new</Typography>
      </Breadcrumbs>
      <Divider className={classes.divider} />
      <FaroParamSetForm
        paramSet={paramSet}
        title="Create Parameter Set"
        assumeRoleArn={assumeRoleArn}
        environments={environmentStore.environments}
        onParamSetChange={setParamSet}
        onSave={onSave}
        onSaveComplete={onSaveComplete}
        onCancel={onCancel}
        onAssumeRoleArnChange={(value: string) => setAssumeRoleArn(value)}
      />

    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default withRouter(withSnackbar(observer(FaroParamSetCreatePage)));
